import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { Button } from 'widget/components';
import * as Env from 'widget/env';

const Submit = () => {
  const { isSubmitting, values } = useFormikContext<Env.Guest>();
  const { t } = useTranslation();

  const isDisabled = !Object.values(values).some(Boolean);

  return (
    <Button isDisabled={isDisabled} isSubmitting={isSubmitting} type="submit">
      {t`Submit`}
    </Button>
  );
};

export default Submit;
